const radConfig = {
  allottement_status: false,
  currentUrl: "https://chartwell.aikenist.com/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://chartwell.aikenist.com/api/quickrad",
  baseUrlRadio: "https://chartwell.aikenist.com/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://chartwell.aikenist.com/aikenviewer/viewer/",
  viewer3DURL:"https://chartwell.aikenist.com/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://chartwell.aikenist.com/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://chartwell.aikenist.com/3daikenviewer/microscopy?StudyInstanceUIDs=",  
  viewerSeg:"https://chartwell.aikenist.com/3daikenviewer/segmentation?StudyInstanceUIDs=",  
  viewerMultiple: "https://chartwell.aikenist.com/3daikenviewer/viewer?",
  viewerMultiplePet: "https://chartwell.aikenist.com/3daikenviewer/tmtv?",
  medDream:"https://chartwell.aikenist.com/?study=",
  thumbnailURL: "https://chartwell.aikenist.com/dicom-web/instances/",
  gifURL:
  "https://chartwell.aikenist.com/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://chartwell.aikenist.com/dicom-web",
  weasisDicomWeb: "https://chartwell.aikenist.com/dicom-web",
  studyList: "https://chartwell.aikenist.com/dicom-web/studies",
  localViewer: "https://chartwell.aikenist.com/aikenviewer/local",
  client: "chartwell",
  paymentComplete: true,
  version: "v2.0",
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp"
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
